import { Dialog } from "primereact/dialog";
import React, { useState, useEffect } from "react";
import {
	Button,
	Modal,
	RadioButtonCore,
	Select,
	Textarea,
	Textfield,
	Timepicker,
} from "../../../../components/core";

export default function SendAppModal({
	open = false,
	onClose,
	data = {
		open: false,
		message: "",
		image: "",
		target: [],
	},
	onSubmit,
	onChange,
	header = "App Message Notification",
	selectedData = [],
}) {
	const [confirmModal, setConfirmModal] = React.useState({ open: false });
	const [dateModal, setDateModal] = useState(false)
	const [scheduleBlastingFlag, setScheduleBlastingFlag] = React.useState(false);
	const [validation, setValidation] = React.useState({
		icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
		title: "",
		message: "",
		open: false,
	});
	const handleImageChange = (event) => {
		const file = event.target.files[0];

		if (file) {
			const reader = new FileReader();

			reader.onloadend = () => {
				// The result property contains the base64-encoded image
				const base64String = reader.result;
				onChange({ target: { name: "image", value: base64String } });
			};

			// Read the image as a data URL
			reader.readAsDataURL(file);
		}
	};

	const handleClearImage = (event) => {
		onChange({ target: { name: "image", value: "" } });
	};


	const formatDate = (dateString) => {
		const options = { month: 'long', day: 'numeric', year: 'numeric' };
		const formattedDate = new Date(dateString).toLocaleDateString('en-US', options);
		return formattedDate;
	}

	const formatTime = (timeString) => {
		const options = { hour: 'numeric', minute: 'numeric', hour12: true };
		const formattedTime = new Date(`2000-01-01T${timeString}`).toLocaleTimeString('en-US', options);
		return formattedTime;
	}

	return (
		<div>
			<Dialog
				header={header}
				closeOnEscape={false}
				visible={open}
				style={{ width: "60vw" }}
				onHide={() => { onClose(); setScheduleBlastingFlag(false); }}
			>
				<div className="w-full h-12 flex gap-6 mb-4 bg-secondary-buttonHeaderGray px-2">
					<RadioButtonCore
						label="Send now"
						checked={scheduleBlastingFlag === false}
						onChange={(e) => {
							setScheduleBlastingFlag(false);
						}}
						className={"my-auto"}
					/>
					<div className="w-1/2 flex gap-2">
						<RadioButtonCore
							label="Schedule Blasting"
							checked={scheduleBlastingFlag === true}
							onChange={(e) => {
								setValidation({
									icon: `${process.env.PUBLIC_URL}/assets/images/warning.png`,
									title: "Warning",
									message:
										"Once a schedule blast is sent, editing is not possible. Do you want to proceed with the blasting?",
									open: true,
									actions: (
										<div className="flex gap-4 my-4">
											<Button
												className={"p-2 w-full"}
												value={"No"}
												onClick={() => setValidation({ open: false })}
											/>
											<Button
												className={"p-2 w-full"}
												value={"Yes"}
												onClick={() => {
													setValidation({ open: false });
													setScheduleBlastingFlag(true);
												}}
											/>
										</div>
									),
								});
							}}
							className={"my-auto"}
						/>
						{scheduleBlastingFlag && (
							<>
								<Textfield
									type="date"
									value={data.schedule}
									onChange={onChange}
									classNameParent="col-span-2 my-auto"
									name="schedule"
								/>
							</>
						)}
						{scheduleBlastingFlag && (
							<Timepicker
								classNameParent={" col-span-2 w-full my-auto"}
								value={data.time}
								onChange={onChange}
								name="time"
							/>
						)}
					</div>
				</div>
				<div className="grid grid-cols-5 w-70 gap-x-2 mr-1">
					<div className="col-span-3">
						<p>Select the destination folder / section:</p>
						<Select
							items={[
								{ name: "System", value: 1 },
								{ name: "Operator", value: 2 },
								{ name: "Pickup", value: 10 },
								{ name: "Shipout", value: 11 },
								{ name: "Voucher", value: 20 },
								{ name: "Others", value: 200 },
							]}
							defaultOption={{
								name: "-- Select Notification Category --",
								value: "-1",
							}}
							value={data.category}
							onChange={onChange}
							className={"w-90 mb-2"}
							name="category"
						/>
						<p>Subject</p>
						<Textarea
							classNameParent="mb-2"
							placeholder={"Type here"}
							value={data.subject}
							onChange={onChange}
							name="subject"
							maxLength={150}
						/>
						<p>Message</p>
						<Textarea
							className="mt-2 w-full"
							placeholder="Please enter a message"
							value={data.message}
							onChange={onChange}
							name="message"
							maxLength={1000}
						/>
						<div className="flex flex-row mt-5">
							<Button
								value={"Cancel"}
								className={"w-40 h-8 mb-2 text-black"}
								onClick={() => { onClose(); setScheduleBlastingFlag(false); }}
							/>
							<div className="mr-5"></div>
							<Button
								value={"Send"}
								className={"w-40 h-8 mb-2 text-black"}
								onClick={() => {
									if (scheduleBlastingFlag) {
										if (data.schedule && data.time) {
											setConfirmModal((prev) => ({ ...prev, open: true }))
										} else {
											setValidation({
												icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
												title: "Select Date and Time",
												message: "Please choose both date and time, or select 'Send now' instead.",
												open: true,
												actions: (<div className="gap-2 w-full mx-auto">
													<Button
														onClick={() => setValidation({ open: false })}
														value={"OK"}
														className={"p-2 w-full"}
													/>
												</div>)
											})
										}
									} else {
										setConfirmModal((prev) => ({ ...prev, open: true }))
									}
								}}
							/>
						</div>
					</div>
					<div className="col-span-2 w-100">
						<p className="font-bold text-lg mb-7">Preview:</p>
						<div
							className={`bg-mbphone bg-no-repeat bg-cover bg-top h-min flex justify-center w-full mx-1 px-1`}
						>
							<div className="grid grid-cols-5 gap-x-4 bg-white border border-gray mt-14	 w-5/6  rounded-md mb-1 p-2">
								<div className="col-span-3">
									<div className="w-full">
										<p className="font-bold line-clamp-1 max-w-full">
											{data.subject === "" ? "Subject here" : data.subject}
										</p>
									</div>

									<div className="w-full h-2/3">
										<p className="line-clamp-2">
											{data.message === "" ? "Message here" : data.message}
										</p>
									</div>
								</div>
								<img
									id="imageContainer"
									className="col-span-2 h-[60px] object-contain mx-auto"
									src={
										data.image == ""
											? "https://www.gstatic.com/mobilesdk/180130_mobilesdk/images/image_placeholder.png"
											: data.image
									}
									alt="image"
								/>
							</div>
						</div>
						<div className="flex flex-row justify-end mx-5 mt-3">
							<Button
								value={"Clear"}
								disabled={data.image == ""}
								className={`w-20 h-8 ${data.image == "" ? "text-white" : "text-black"
									}`}
								onClick={handleClearImage}
							/>
							<div className="w-4"></div>
							<Button
								value={"Upload Image"}
								className="w-40 h-8 text-black"
								onClick={(e) => document.getElementById("fileInput").click()}
							/>
							<input
								type="file"
								id="fileInput"
								style={{ display: "none" }}
								accept="image/*"
								onChange={handleImageChange}
							></input>
						</div>
						<div className="p-2">
							<p className="font-bold">Note:</p>
							<ul>
								<li>
									* Image must be max of <b>1MB</b>
								</li>
								<li>
									* Only accepts <b>JPG and PNG</b> format.
								</li>
							</ul>
						</div>
					</div>
				</div>
			</Dialog>
			<Dialog
				visible={confirmModal.open}
				onHide={() => setConfirmModal((prev) => ({ ...prev, open: false }))}
				header={`This will send an email to ${selectedData.length > 1000 ? data.target.length : selectedData.length
					} user/s, confirm?`}
			>
				<div className="flex flex-row justify-end mr-5">
					<Button
						value={"Cancel"}
						className={"w-40 h-8 mb-2 text-black"}
						onClick={() =>
							setConfirmModal((prev) => ({ ...prev, open: false }))
						}
					/>
					<div className="mr-5"></div>
					<Button
						value={"Confirm"}
						className={"w-40 h-8 mb-2 text-black"}
						onClick={() => {
							setConfirmModal((prev) => ({ ...prev, open: false }))

							// setDateModal((prev) => ({ ...prev, open: true }))

							if (scheduleBlastingFlag) {
								setDateModal((prev) => ({ ...prev, open: true }))
							} else {
								if (data.message == "" || data.category.value == "-1") {
									setValidation({
										icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
										title: "Incomplete Data",
										message: "Please complete all the fields to send this message.",
										open: true,
										actions: (<div className="gap-2 w-full mx-auto">
											<Button
												onClick={() => setValidation({ open: false })}
												value={"OK"}
												className={"p-2 w-full"}
											/>
										</div>)
									})
								} else {
									onSubmit();
								}

							}
						}}
					/>
				</div>
			</Dialog>

			<Dialog visible={dateModal.open && scheduleBlastingFlag}
				onHide={() => setDateModal((prev) => ({ ...prev, open: false }))}
				header={`This blast will be sent on ${formatDate(data.schedule)} at ${formatTime(data.time)}`} className="p-4">
				<div className="flex flex-row justify-center items-center mr-5">
					<Button
						value={"Cancel"}
						className={"w-40 h-8 mb-2 text-black"}
						onClick={() =>
							setDateModal((prev) => ({ ...prev, open: false }))
						}
					/>
					<div className="mr-5"></div>
					<Button
						value={"Confirm"}
						className={"w-40 h-8 mb-2 text-black"}
						onClick={() => {
							setDateModal((prev) => ({ ...prev, open: false }));
							///empty validation
							if (data.message == "" || data.category.value == "-1") {
								setValidation({
									icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
									title: "Incomplete Data",
									message: "Please complete all the fields to send this message.",
									open: true,
									actions: (<div className="gap-2 w-full mx-auto">
										<Button
											onClick={() => setValidation({ open: false })}
											value={"OK"}
											className={"p-2 w-full"}
										/>
									</div>)
								})
							} else {
								onSubmit();
							}

						}}
					/>
				</div>
			</Dialog>
			<Modal
				icon={validation.icon}
				title={validation.title}
				message={validation.message}
				open={validation.open}
				actions={validation.actions}
			/>
		</div>
	);
}
